var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanQrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_3046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83337 4.33325V6.33325H4.83337V4.33325H6.83337ZM7.83337 3.33325H3.83337V7.33325H7.83337V3.33325ZM6.83337 9.66659V11.6666H4.83337V9.66659H6.83337ZM7.83337 8.66659H3.83337V12.6666H7.83337V8.66659ZM12.1667 4.33325V6.33325H10.1667V4.33325H12.1667ZM13.1667 3.33325H9.16671V7.33325H13.1667V3.33325ZM9.16671 8.66659H10.1667V9.66659H9.16671V8.66659ZM10.1667 9.66659H11.1667V10.6666H10.1667V9.66659ZM11.1667 8.66659H12.1667V9.66659H11.1667V8.66659ZM9.16671 10.6666H10.1667V11.6666H9.16671V10.6666ZM10.1667 11.6666H11.1667V12.6666H10.1667V11.6666ZM11.1667 10.6666H12.1667V11.6666H11.1667V10.6666ZM12.1667 9.66659H13.1667V10.6666H12.1667V9.66659ZM12.1667 11.6666H13.1667V12.6666H12.1667V11.6666ZM15.1667 4.66659H13.8334V2.66659H11.8334V1.33325H15.1667V4.66659ZM15.1667 14.6666V11.3333H13.8334V13.3333H11.8334V14.6666H15.1667ZM1.83337 14.6666H5.16671V13.3333H3.16671V11.3333H1.83337V14.6666ZM1.83337 1.33325V4.66659H3.16671V2.66659H5.16671V1.33325H1.83337Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_3046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQrIcon);
export default __webpack_public_path__ + "static/media/scan-qr-icon.b0e3f4579d6b61deba5b391732f1a42b.svg";
export { ForwardRef as ReactComponent };